var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper-card-audit" },
    [
      _vm.loading
        ? [_vm._m(0)]
        : [
            _vm.hasError
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "alert alert-danger",
                      attrs: { role: "alert" },
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(_vm.errorMsg) + "\n\t\t\t")]
                  ),
                ]
              : _vm.isLoaded
              ? [
                  _c(
                    "div",
                    { staticClass: "result-audit" },
                    [
                      _vm.hasAudits
                        ? _vm._l(_vm.audits, function (audit) {
                            return _c(
                              "div",
                              { key: `audit-${audit.id}`, staticClass: "card" },
                              [
                                _c("div", { staticClass: "card-header" }, [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          `${_vm.idPanel}.${audit?.event}.metadata`,
                                          {
                                            ...audit,
                                            ...{
                                              user_name: audit?.user?.name,
                                              user_email: audit?.user?.email,
                                            },
                                          }
                                        )
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "card-body" }, [
                                  _c(
                                    "div",
                                    { staticClass: "table-responsive" },
                                    [
                                      _c(
                                        "table",
                                        { staticClass: "table table-bordered" },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "w-200px" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `${_vm.idPanel}.list.attribute`
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("th", [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-6" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `${_vm.idPanel}.list.old`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-6" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `${_vm.idPanel}.list.new`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              audit.data,
                                              function (
                                                modified,
                                                attribute,
                                                index
                                              ) {
                                                return _c(
                                                  "tr",
                                                  {
                                                    key: `audit-${audit.id}-attribute-${attribute}`,
                                                  },
                                                  [
                                                    _c("td", [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `${_vm.translatePrefix}.${attribute}`
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _c("table", [
                                                        _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "old",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      `${_vm.translatePrefix}.${attribute}`
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "new",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      `${_vm.translatePrefix}.${attribute}`
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          })
                        : [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-100 text-center alert alert-info",
                                attrs: { role: "alert" },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(`${_vm.idPanel}.unavailable`)
                                    ) +
                                    "\n\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading" }, [
      _c("div", {}, [_c("div", { staticClass: "full-size-loader" })]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }